import service from '../api/country.service';
//constants
const data = {
    countries: [],
    countryAdd: null,
    responseCountry: null,
    noPermitted: ''
}
//types
const LIST_COUNTRY = 'LIST_COUNTRY';
const LIST_COUNTRY_ERROR = 'LIST_COUNTRY_ERROR';
const ADD_COUNTRY = 'ADD_COUNTRY';
const UPDATE_COUNTRY = 'UPDATE_COUNTRY';
const DELETE_COUNTRY = 'DELETE_COUNTRY';

//reducer
export default function countryReducer(state = data, action) {
    switch (action.type) {
        case LIST_COUNTRY:
            return { ...state, countries: action.payload };
        case ADD_COUNTRY:
            return { ...state, countryAdd: action.payload };
        case LIST_COUNTRY_ERROR:
            return { ...state, noPermitted: action.payload };
        default:
            return { ...state };
    }
}

export const findCountries = (user) => async (dispatch) => {
    const response = await service.getCountries(user,0).then((r) => { return r.data });
    let data = [];


    if (response != null) {
        if (response.code === undefined) {
            response.forEach((element) => {
                data.push({
                    value: element.id,
                    label: '[' + element.code + '] ' + element.name.toUpperCase(),
                    code: element.code
                });
            });
        } else {
            dispatch({
                type: LIST_COUNTRY_ERROR,
                payload: response.message
            });
        }
    }
    dispatch({
        type: LIST_COUNTRY,
        payload: data
    });
}
export const findPlainCountries = (user) => async (dispatch) => {
    const response = await service.getCountries(user,0).then((r) => { return r.data });
    let data = [];

    if (response != null) {
        if (response.code === undefined) {
            response.forEach((element) => {
                data.push({
                    value: element.name.toUpperCase(),
                    label: element.name.toUpperCase(),
                    code: element.code
                });
            });
        } else {
            dispatch({
                type: LIST_COUNTRY_ERROR,
                payload: response.message
            });
        }
    }
    dispatch({
        type: LIST_COUNTRY,
        payload: data
    });
}
export const findRawCountries = (user) => async (dispatch) => {
    const response = await service.getCountries(user,1).then((r) => { return r.data });

    dispatch({
        type: LIST_COUNTRY,
        payload: response
    });
    return response;
}

export const saveCountry = (countryData) => async (dispatch) => {
    const response = await service.saveCountry(countryData).then((r) => { return r.data });
    dispatch({
        type: ADD_COUNTRY,
        payload: response
    });
    return response;
}
export const updateCountry = (countryData) => async (dispatch) => {
    const response = await service.updateCountry(countryData).then((r) => { return r.data });

    dispatch({
        type: UPDATE_COUNTRY,
        payload: response
    });
    return response;
}

export const deleteCountry = (countries) => async (dispatch) => {
    const response = await service.deleteCountry(countries).then((r) => { return r.data });

    dispatch({
        type: DELETE_COUNTRY,
        payload: response
    });
    return response;
}